<template>
    <div class="bslip-item fadeInUp" :class="itemStatus" ref_testcafe="frontendSelectedMatches">
        <div class="bslip-item-left" v-if="betslip.betslipDef == 'combination'">
          <i class="icon-fix iconset bslip-fixicon" v-on:click="betslip.changeItemFix(itemIndex)" :class="(item.fix ? 'active' : '')"></i>
        </div>
        <div class="bslip-teams">
            <p class="bslip-teams-names" v-if="item.type === 'lotto_extended'">{{item.eventName}}</p>
            <p class="bslip-teams-names" v-else v-html="itemName"></p>
            <p class="bslip-game-part">{{$t(item.meta.marketName.toUpperCase(), item.meta.specifiers)}}{{getModifier}}</p>
        </div>
        <div class="bslip-item-right">
            <div class="bslip-odds-container">
                <div class="bslip-odd-type">{{$t(itemOutcomeName.toUpperCase())}}</div>
                <div class="bslip-odd-value">{{item.meta.coefficient | formatOdd}}</div>
            </div>
            <p class="bslip-item-date">{{$formatTicketMatchDate(item, 'DD.MM. HH:mm')}}</p>
        </div>
        <div v-if="isMobile" class="mtitem-delete" v-on:click="selectEvent(item)">
          <div class="mtitem-dlt-button">
            <i class="iconset icon-delete"></i>
          </div>
        </div>

        <div class="titem-delete" v-on:click="selectEvent(item)">
          <div class="titem-dlt-button">
            <i class="iconset icon-delete"></i>
          </div>
        </div>
    </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from 'vuex';

export default {
    name: 'TicketLottoExtendedItem',
    props: ['item', 'itemIndex'],
    methods: {
        ...mapActions([
            'selectEvent',
        ]),
    },
    watch: { },
    computed:
    {
        ...mapGetters([
            'betslip',
            'isMobile',
            'globals',
        ]),
        itemStatus()
        {
            const me = this;

            let status = 'is-unavailable';

            if (me.item.status === undefined || me.item.status === '' || me.item.status === 'active')
            {
                status = 'is-active';
            }
            if (me.item.status === 'block')
            {
                status = 'is-blocked';
            }

            return status;
        },
        itemMarketName()
        {
            const me = this;

            let field = 'marketName';

            if (me.globals.publicConfig != null
            && me.globals.publicConfig.website != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings.ticketEventMarket != null)
            {
                field = me.globals.publicConfig.website.sportOfferMarketOutcomeSettings.ticketEventMarket;
            }

            if (field === 'both')
            {
                let textOut = me.item.meta.marketName;

                if (me.item.meta.marketShortName != null)
                {
                    textOut += ` (${me.item.meta.marketShortName})`;
                }

                return textOut;
            }

            if (me.item.meta[field] != null)
            {
                return me.item.meta[field];
            }

            return me.item.meta.marketName;
        },
        itemOutcomeName()
        {
            const me = this;

            let field = 'outcomeName';

            if (me.globals.publicConfig != null
            && me.globals.publicConfig.website != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings != null
            && me.globals.publicConfig.website.sportOfferMarketOutcomeSettings.ticketEventOutcome != null)
            {
                field = me.globals.publicConfig.website.sportOfferMarketOutcomeSettings.ticketEventOutcome;
            }

            if (field === 'both')
            {
                let textOut = me.item.meta.outcomeName;

                if (me.item.meta.outcomeShortName != null)
                {
                    textOut += ` (${me.item.meta.outcomeShortName})`;
                }

                return textOut;
            }

            if (me.item.meta != null
            && me.item.meta[field] != null)
            {
                return me.item.meta[field];
            }

            return me.item.meta.outcomeName;
        },
        getModifier()
        {
            const me = this;
            let modifier = '';

            if (me.item.type !== 'lotto_extended')
            {
                return modifier;
            }

            if (me.item.meta != null
            && me.item.meta.hasModifier === 1)
            {
                modifier = ` (${me.item.modifierName}: ${me.item.modifierValue})`;
            }

            return modifier;
        },
        itemName()
        {
            const me = this;

            const name = me.item.eventName;

            return name;
        },
    },
};
</script>
